import React, { useState, useEffect } from 'react';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Contact = ({ scrollPosition }) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const sectionElement = document.getElementById('contact');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsInView(entry.isIntersecting));
      },
      { threshold: 0.1 },
    );

    if (sectionElement) observer.observe(sectionElement);

    return () => {
      if (sectionElement) observer.unobserve(sectionElement);
    };
  }, []);

  const sectionStyle = {
    transition: 'opacity 0.5s ease, transform 0.5s ease',
    opacity: isInView ? 1 : 0,
    transform: isInView ? 'translateY(0)' : 'translateY(20px)',
    visibility: isInView ? 'visible' : 'hidden',
  };
  return (
    <section id="contact" className="contact section" style={sectionStyle}>
      {/* Section Title */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Kontak</h2>
        <p>
          Butuh bantuan atau informasi lebih lanjut? Kami siap membantu Anda
          dalam hal pendaftaran, janji temu, dan layanan kesehatan lainnya.
        </p>
      </div>
      {/* End Section Title */}

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          {/* Embed Map */}
          <div className="col-lg-6">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15952.746401541872!2d103.57840175!3d-1.6386971000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e2587cf9885f1df%3A0x911edc77c1f636e9!2sRSUD%20H.%20Abdul%20Manap%20Jambi!5e0!3m2!1sen!2sid!4v1732604741925!5m2!1sen!2sid"
              width="100%"
              height="450"
              style={{ border: 0 }}
              title="Lokasi Map RSUD H Abdul Manap Kota Jambi"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          {/* End Embed Map */}

          {/* Contact Info */}
          <div className="col-lg-6">
            <div className="row gy-4">
              <div className="col-lg-12">
                <div
                  className="info-item d-flex flex-column justify-content-center align-items-center"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <i className="bi bi-geo-alt"></i>
                  <h3>Alamat</h3>
                  <p style={{ textAlign: 'center' }}>
                    Jl. Sk. Rd. Syahbudin Mayang Mangurai Alam Barajo Kota Jambi
                    36129
                  </p>
                </div>
              </div>
              {/* End Info Item */}

              <div className="col-md-6">
                <a
                  href="tel:07415910180"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div
                    className="info-item d-flex flex-column justify-content-center align-items-center"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <i className="bi bi-telephone"></i>
                    <h3>Telephone</h3>
                    <p>0741-5910180</p>
                  </div>
                </a>
              </div>
              {/* End Info Item */}

              <div className="col-md-6">
                <a
                  href="mailto:rsudjambikota@gmail.com"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div
                    className="info-item d-flex flex-column justify-content-center align-items-center"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <i className="bi bi-envelope"></i>
                    <h3>Email</h3>
                    <p>rsudjambikota@gmail.com</p>
                  </div>
                </a>
              </div>
              {/* End Info Item */}
            </div>
          </div>
          {/* End Contact Info */}
        </div>
      </div>
    </section>
  );
};

export default trackWindowScroll(Contact);
